
export const VISA_PATTERN = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
export const MAST_PATTERN = /^(?:5[1-5][0-9]{14})$/;
export const AMEX_PATTERN = /^(?:3[47][0-9]{13})$/;
export const DISC_PATTERN = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;

export function getCreditCardType(ccNum) {
    const VISA_PATTERN = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    const MAST_PATTERN = /^(?:5[1-5][0-9]{14})$/;
    const AMEX_PATTERN = /^(?:3[47][0-9]{13})$/;
    const DISC_PATTERN = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
    const isVisa = VISA_PATTERN.test( ccNum ) === true;
    const isMast = MAST_PATTERN.test( ccNum ) === true;
    const isAmex = AMEX_PATTERN.test( ccNum ) === true;
    const isDisc = DISC_PATTERN.test( ccNum ) === true;

    if( isVisa || isMast || isAmex || isDisc) {

        if( isVisa ) {
            return "visa"
        }
        else if( isMast ) {
            return "mast"
        }
        else if( isAmex ) {
            return "amex";
        }
        else if( isDisc ) {
            return "disc";
        }
    }
    else {
        return "unknown";
    }
}

export function checkId(passport) {
    let sum = 0;

    for (let i = 0; i < passport.length; i++) {
        let cardNum = parseInt(passport[i]);

        if ((passport.length - i) % 2 === 0) {
            cardNum = cardNum * 2;

            if (cardNum > 9) {
                cardNum = cardNum - 9;
            }
        }

        sum += cardNum;
    }

    return sum % 10 === 0;
}


